export const externalAccount = {
  EXTERNAL_ACCOUNT: 'ovps/{ovpName}/keys',
  FETCH_EVENTBRITE_ORGANIZATIONS: 'ovps/eventbrite/organizations',
  FETCH_EVENTBRITE_VIDEOS: 'ovps/eventbrite/videos',
  CREATE_LIVELIKE_ACCOUNT: 'v2/ovps/livelike/connect',
  DISCONNECT_LIVELIKE_ACCOUNT: 'v2/ovps/livelike/disconnect',
};
